import { useMemo } from "react"

import {
  SUPPLIER_ONBOARDING_STEP_DEFS,
  type SupplierOnboardingStepId,
} from "~/pages/SupplierPortal/Onboarding/constants/supplierOnboardingSteps"

type OnboardingStubState = Readonly<{
  status: "not_started" | "in_progress"
  currentStepId: SupplierOnboardingStepId
}>

/**
 * Temporary front-end stub while onboarding API contracts are under review.
 * Replace this hook with generated API queries/mutations once TASK-3179 lands.
 */
export const useOnboardingStateStub = (): OnboardingStubState => {
  return useMemo(
    () => ({
      status: "not_started",
      currentStepId: SUPPLIER_ONBOARDING_STEP_DEFS[0].id,
    }),
    []
  )
}
